import NotFound from "../components/layout/NotFound"

export default [
  { name: 'NotFound', path: '/404', component: NotFound}
]
